import { FeatureFlag } from '../FeatureFlag';

export const showInviteCodesForProfessionalTraders = new FeatureFlag({
    key: 'show-invite-codes-for-professional-traders',
    defaultValue: false,
});
